const states = [
  { name: "ANDAMAN AND NICOBAR", code: "35" },
  { name: "ANDHRA PRADESH", code: "37" },
  { name: "ARUNACHAL PRADESH", code: "12" },
  { name: "ASSAM", code: "18" },
  { name: "BIHAR", code: "10" },
  { name: "CHANDIGARH", code: "4" },
  { name: "CHHATTISGARH", code: "22" },
  { name: "DADRA AND NAGAR HAVELI", code: "26" },
  { name: "DAMAN AND DIU", code: "25" },
  { name: "DELHI", code: "7" },
  { name: "GOA", code: "30" },
  { name: "GUJARAT", code: "24" },
  { name: "HARYANA", code: "6" },
  { name: "HIMACHAL PRADESH", code: "2" },
  { name: "JAMMU AND KASHMIR", code: "1" },
  { name: "JHARKHAND", code: "20" },
  { name: "KARNATAKA", code: "29" },
  { name: "KERALA", code: "32" },
  { name: "LADAKH", code: "38" },
  { name: "LAKSHADWEEP", code: "31" },
  { name: "MADHYA PRADESH", code: "23" },
  { name: "MAHARASHTRA", code: "27" },
  { name: "MANIPUR", code: "14" },
  { name: "MEGHALAYA", code: "17" },
  { name: "MIZORAM", code: "15" },
  { name: "NAGALAND", code: "13" },
  { name: "ODISHA", code: "21" },
  { name: "Other Territory", code: "97" },
  { name: "OTHER COUNTRIES (Registered)", code: "96" },
  { name: "OTHER COUNTRIES (Unregistered)", code: "99" },
  { name: "PUDUCHERRY", code: "34" },
  { name: "PUNJAB", code: "3" },
  { name: "RAJASTHAN", code: "8" },
  { name: "SIKKIM", code: "11" },
  { name: "TAMIL NADU", code: "33" },
  { name: "TELANGANA", code: "36" },
  { name: "TRIPURA", code: "16" },
  { name: "UTTAR PRADESH", code: "9" },
  { name: "UTTARAKHAND", code: "5" },
  { name: "WEST BENGAL", code: "19" }
];

export default states;
